import Text from "./Text";
import { useModal } from "./Modal";
import { useNavigate } from "react-router-dom";
import Button from "./Buttons/Button";
import InstallAppButton from "./Buttons/Variants/InstallAppButton";
import { useWebSocket } from "../Context/WebSocketContext";
import SubscriptionHelper from "../Helper/SubscriptionHelper";
import TimeTrackingReport from "./TimeTrackingReport";
import Footer from "./Footer";
import Impressum from "./Impressum";
import AGB from "./AGB";
import DSE from "./DSE";
import TIcon from "./TIcon";

const Avatar = ({ firstname, lastname, preview = false }) => {
    const { isOnline } = useWebSocket();
    const { ModalView, openModal } = useModal()
    const navigate = useNavigate();
    const first = firstname.charAt(0).toUpperCase();
    const last = lastname.charAt(0).toUpperCase();
    const { isAllowed, hasActive } = SubscriptionHelper()

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        navigate("/app/login");
    };

    const handleAvatarClick = () => {
        if (!preview) {
            openModal(
                <div className="h-full flex flex-col pt-5 gap-2">
                    <Text type="maintitle">{firstname} {lastname}</Text>
                    {isAllowed("allowTimeTracking") && hasActive("useTimeTracking") && isOnline && (
                        <Button tIconName={"report"} text={"Arbeitszeiten ansehen"} onClickAction={() => handleUserTimeClick()} />
                    )}
                    <Button buttonColor="bg-green-400" classNames="gap-1" tIconName={"reload"} onClickAction={() => { window.location.reload() }} text={"Aktualisieren"} />
                    <InstallAppButton />
                    <Button onClickAction={() => handleLogout()}>
                        <Text type="buttontext" classNames={"text-red-500"}>Logout</Text>
                    </Button>
                    <Footer />
                    {footerItemWrapper("Impressum", <Impressum />)}
                    {footerItemWrapper("Datenschutzerklärung", <DSE />)}
                    {footerItemWrapper("AGB", <AGB />)}
                </div>
            )
        }
    }

    const footerItemWrapper = (title, modalContent) => {
        return (<div onClick={() => { openModal(modalContent) }}>
            <Text classNames={"hover:underline"}>{title}</Text>
        </div>)
    }

    const handleUserTimeClick = () => {
        openModal(
            <TimeTrackingReport />
        )
    }

    return (
        <div className="flex items-center gap-2">
            {!preview && (
                <TIcon name={isOnline ? "wifi" : "wifi-off"} size={20} color={isOnline ? "green" : "red"} stroke={2} className="mr-2" />
            )}
            <div
                className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-300 cursor-pointer"
                onClick={handleAvatarClick}
            >
                <Text type="orderitem">{first}{last}</Text>
            </div>
            <ModalView classNames="w-auto max-h-full h-[80vh]" />
        </div>
    )
}

export default Avatar